import { testimonials } from "@/mocks/observeData";
import { SectionHeading, SectionShell } from "./common";

const principles = [
  {
    icon: "ri-focus-3-line",
    title: "只信有出处的信息",
    desc: "一切判断以企业公告、监管通报与可靠信源为依据，网络截图与匿名爆料仅作线索提示，不作定论依据。",
  },
  {
    icon: "ri-scales-3-line",
    title: "平衡呈现多方说法",
    desc: "涉及具体企业时同步整理消费者反映与企业回应，避免单方面放大某一方声音造成误读。",
  },
  {
    icon: "ri-timer-line",
    title: "信息随事件更新",
    desc: "事件是流动的。每条内容标注核实状态与更新日期，事实有进展时及时修正，不把旧结论当永久真相。",
  },
  {
    icon: "ri-spy-line",
    title: "克制比博眼球重要",
    desc: "我们相信长久的公信力来自克制。宁可少一个流量标题，也不让一条未经证实的指控借我们传播。",
  },
];

export default function AboutSection() {
  return (
    <SectionShell id="about" className="bg-background-50 py-14 md:py-20">
      <SectionHeading
        eyebrow="ABOUT US"
        title="关于99黑料"
        align="center"
        desc="我们是谁、相信什么，以及为什么坚持用最“笨”的方式做信息。"
      />

      <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
        <div className="flex flex-col justify-center">
          <p className="font-heading text-2xl font-bold leading-snug text-foreground-950">
            与其让你在无数截图与传言里疲于辨认，
            <span className="text-primary-600"> 不如把‘能查证的那部分’先整理清楚。</span>
          </p>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
            99黑料是一家专注企业与品牌舆情观察与消费避坑的资讯站。我们围绕食品、数码、美妆、金融、汽车、本地生活等行业，
            持续追踪公众关注的产品服务问题与品牌争议，把它们整理成可读、可查、可照做的信息。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们很清楚“黑料”二字自带流量，因此更提醒自己守住底线：议题可以有热度，观点必须守分寸，
            证据永远是编辑部的第一语言。本站面向每一位想在消费前把风险看清楚、把信息辨明白的普通人。
          </p>
          <div className="mt-7 flex flex-wrap gap-4">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              和我们交流
              <i className="ri-send-plane-line" />
            </a>
            <a
              href="#report"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-3 text-sm font-bold text-foreground-800 transition-colors hover:bg-background-100 cursor-pointer"
            >
              查看深度专题
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {principles.map((p) => (
            <div key={p.title} className="rounded-lg border border-background-200 bg-background-100/60 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-800">
                <i className={`${p.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-14">
        <div className="flex items-center gap-4">
          <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">读者口碑</h3>
          <span className="h-px flex-1 bg-secondary-200" />
        </div>
        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex flex-col rounded-lg border border-background-200 bg-background-100/50 p-6">
              <div className="flex gap-1 text-accent-500">
                {[0, 1, 2, 3, 4].map((n) => (
                  <i key={n} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.content}”
              </blockquote>
              <figcaption className="mt-5 inline-flex items-center gap-2.5 text-sm text-foreground-600">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-user-3-line text-sm" />
                </span>
                {t.name}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </SectionShell>
  );
}